export default {
  title: 'Update Required',
  text: "You're currently using an older version of the app. To continue enjoying all features and ensure optimal performance, please update to the latest version. Tap the button below to go to the App Store or Google Play and install the update. Thank you for staying up to date!",
  openAppStore: 'Update Now'
}